(function() {
    'use strict';
    angular.module('wbUtilities').directive('allocationSliderGlide', ['RiskScore', function(RiskScore) {
        /**
         */
    return {
        restrict: 'A',
        scope: {
            allocationValue: '=ngModel',
            recommended: '=?',
            otherTick: '=?',
            cashRate: '=?',
            disabled: '<?',
            detailAction: '&?',
            resetAction: '&?'
        },
        templateUrl: "/common/src/app/directives/allocation-slider-glide/allocation-slider-glide.tpl.html",
        link: function(scope, $el, attrs) {

            scope.recommendedDelta = 1.2;

            scope.risk = {
                portfolios: null,
                simpleAllocation: null,
                displayStocks: null,
                displayBonds: null,
                trueStocks: null,
                trueBonds: null,
            };

            scope.tick = {
                default: {
                    ticks: [0.9, 10.1],
                    positions: [0, 100]
                }
            };

            //so proper reference to allocationValue can be used in template
            scope.scope = scope;

            scope.$watch(function() { return RiskScore.getPortfolios(); }, function(portfolios) {
                scope.risk.portfolios = portfolios;
                scope.updateSimpleAllocation();
            });
            scope.$watchGroup(["allocationValue", "cashRate"], function (data) {
                var [allocationValue, cashRate] = data;

                if (allocationValue || allocationValue === 0) {

                    scope.updateSimpleAllocation();
                }
            });
            scope.updateSimpleAllocation = function() {
                var allocationValue = scope.allocationValue;
                var cashRate = scope.cashRate;
                var displayDecimal = 0;
                if (scope.risk.portfolios && (allocationValue || allocationValue===0)) {

                    scope.risk.trueStocks = scope.risk.portfolios[allocationValue.toFixed(1)].stock_percent  * (1-scope.cashRate);
                    scope.risk.trueBonds = scope.risk.portfolios[allocationValue.toFixed(1)].bond_percent  * (1-scope.cashRate);
                    if (scope.risk.trueStocks < 10 && scope.risk.trueBonds < 10) {
                        displayDecimal = 1;
                        if (scope.risk.trueStocks <= 1 && scope.risk.trueBonds <= 1) {
                            displayDecimal = 2;
                        }
                    }
                    scope.risk.displayStocks = scope.risk.trueStocks.toFixed(displayDecimal);
                    scope.risk.displayBonds = scope.risk.trueBonds.toFixed(displayDecimal);


                    if (allocationValue < 0.9) { allocationValue = 0; }
                    if (allocationValue === 0) { cashRate = 1; }

                    if (cashRate < 1 && cashRate >= 0.9) {
                        //scale cash so it never gets higher than 95% displayed on graph
                        cashRate = 0.9 + (cashRate - 0.9)/2;
                    }

                    scope.risk.simpleAllocation = RiskScore.getSimpleAllocation(allocationValue.toFixed(1), cashRate*100);
                } else {
                    scope.risk.simpleAllocation = {
                        "total_value": undefined,
                        "positions": [
                                {"category": "Stock", "percent": 33.33, "code": "stock"},
                                {"category":  "Bond", "percent": 33.33, "code": "bond"},
                                {"category":  "Cash", "percent": 33.33, "code": "USD"}
                            ]
                    }
                }
            };
            scope.setRiskToRecommended = function() {
                if (scope.resetAction) {
                    scope.resetAction();
                } else {
                    scope.allocationValue = scope.recommended*1;
                }
            };

            /**
             *
             * @returns {integer}
             * @returns 2 = is above recommended
             * @returns 1 = is on low side of recommended
             * @returns 0 = is exact recommended
             * @returns -1 = is on low side of recommended
             * @returns -2 = is below recommended
             */
            scope.recommendedOffset = function() {
                var offset = null;

                var value = scope.allocationValue;
                var low = scope.recommended*1 - scope.recommendedDelta;
                var high = scope.recommended*1 + scope.recommendedDelta;
                var exact = scope.recommended*1;

                if ( value === exact) {
                    offset = 0;
                } else if (low <= value && value < exact ) {
                    offset = -1;
                } else if (exact < value && value <= high ) {
                    offset = 1;
                } else if (value < low) {
                    offset = -2;
                } else if (high < value) {
                    offset = 2;
                }
                return offset;
            };

            scope.$watch("otherTick", function (tickScore) {
                //other tick is used for showing the other allocation (end or start) while editing the current one (start or end)
                if (tickScore) {
                    var scoreAsPercent;

                    //get score as the percent of 1-10
                    scoreAsPercent = (tickScore*1 - 0.9) / (10.1 - 0.9) * 100;
                    scoreAsPercent = Math.round(scoreAsPercent*10)/10;

                    scope.tick.ticks = [scope.tick.default.ticks[0], tickScore*1, scope.tick.default.ticks[1]];
                    scope.tick.positions = [scope.tick.default.positions[0], scoreAsPercent, scope.tick.default.positions[1]];
                } else {
                    scope.tick.ticks = scope.tick.default.ticks;
                    scope.tick.positions = scope.tick.default.positions;
                }

            });
            scope.$watch("recommended", function (recommended) {
                if (recommended) {
                    scope.tick.recommendStart = Math.max(recommended*1 - scope.recommendedDelta, 0.9);
                    scope.tick.recommendEnd = Math.min(recommended*1 + scope.recommendedDelta, 10.1);
                }
            });
        }};
    }]);
})();
